import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import CustomButton from '../../components/CustomButton';
import {login as LoginAction} from "../../redux/actions/login";
import LOGO from './../../assets/images/snapdc_logo.png';
const Login = (props) => {
    const dispatch = useDispatch();
    let {login_waiting, login_success}  = useSelector(state => state.login)
    const [loginData,setLoginData] = useState({
        username : '',
        password : ''
    })
    const login = (e) => {
        e.preventDefault();
        dispatch(LoginAction(loginData))
    }
    useEffect(() => {
        if (login_success.result && login_success.result === 'SUCCESS'){
            localStorage.setItem('token',login_success.data.access_token);
            localStorage.setItem('user',JSON.stringify(login_success.data.user));
            window.location.reload();
        }
    },[login_success]);
    return (
        <div className="row justify-content-center">
            <div className="col-md-6 login-holder">
                <img src={LOGO} alt="" width={150}/>
                <div className="card shadow-sm">
                    <div className="card-header text-center">ورود به پنل مدیریت سرویس</div>
                    <div className="card-body">
                        <form method="POST">
                            <div className="form-group row">
                                <label htmlFor="username" className="col-md-4 col-form-label text-md-right">نام کاربری :  </label>
                                <div className="col-md-8">
                                    <input id="username" type="text"
                                           className="form-control"
                                           name="username"
                                           autoFocus={true}
                                           onChange={(username) => {
                                               username = username.target.value;
                                               setLoginData((prevState) => {
                                                   prevState.username = username;
                                                   return ({...prevState});
                                               })
                                           }}
                                           required autoComplete="username"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="password" className="col-md-4 col-form-label text-md-right">رمز عبور :  </label>
                                <div className="col-md-8">
                                    <input id="password" type="password"
                                           className="form-control" name="password"
                                           onChange={(password) => {
                                               password = password.target.value;
                                               setLoginData((prevState) => {
                                                   prevState.password = password;
                                                   return ({...prevState});
                                               })
                                           }}
                                           required autoComplete="password"
                                    />
                                </div>
                            </div>
                            <div className="form-group row mb-0">
                                <div className="col-md-4 col-form-label text-md-right" />
                                <div className="col-md-8">
                                    <CustomButton
                                        action={(e) => login(e)}
                                        loading={login_waiting}
                                        content="ورود"
                                        type='success'
                                        block={true}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;
